import styled from 'styled-components';

import {
  Flex,
  Text,
  Container,
} from 'web-styled';

export const PageWrap = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  min-height: 100%;
  flex: 0 0 100%;
  background: #fff;
  overflow: auto;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
`;

export const ClientContainer = styled(Flex).attrs({
  spacing: 30,
  padding: '30px',
  align: 'center',
  justify: 'center',
  fillSpace: true,
})`
  background: linear-gradient(to bottom, ${props => props.theme.colors.primaryBright} 50%, #fff 50%);
  padding-top: 30px;
  background-size: cover;
`;

export const FormLogo = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  width: calc(100% + 40px);
  padding: 10px 15px 30px 15px;
  margin-left: -20px;
  margin-right: -20px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);

  img {
    max-width: 35%;
  }
`;

export const PageContainer = styled(Container).attrs({
  margin: '5% auto 0 auto',
  padding: '35px',
})`
  @media (max-width: 960px) {
    flex-wrap: wrap;
    width: 100%;
    margin: 0;
    padding: 0 15px;
    justify-content: center;
  }
`;

export const SpeechContainer = styled(Flex).attrs({
  column: true,
  spacing: 10,
})`
  @media (min-width: 961px) {
    flex: 50%;
    margin-right: 30px;
  }

  @media (max-width: 960px) {
    padding: 30px;
    width: 100%;
  }
`;

export const Speech = styled.p`
  font-weight: 400;
  line-height: 1.5;
  font-size: 20px;
`;

export const Signature = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  img {
    border-radius: 100%;
    max-width: 104px;
    height: auto;
  }
`;

export const SignatureName = styled.h4`
  font-family: AvenirNextLTPro-Bold;
  margin: 0px;
  font-size: 20px;
`;

export const SignaturePosition = styled.h5`
  font-weight: 300;
  margin-top: 10px;
  font-size: 15px;
`;

export const FormTitle = styled.h4`
  font-weight: bold;
  font-family: AvenirNextLTPro-Bold;
  margin-top: 20px;
`;

export const Form = styled(Flex).attrs({
  as: 'form',
})`
  width: 100%;
  box-shadow: 0 8px 40px rgba(0, 116, 217, .1);
  border: 1px solid #ececec;
  background: #fff;
  padding: 20px;
  label {
    color: #000;
    font-size: 14px;
    font-weight: 600;
  }
  .agreement + label {
    font-weight: 400;
  }
`;

export const TextCenter = styled(Flex)`
  justify-content: center;
  width: 100%;
  text-align: center;
  margin-top: 15px;
`;

export const CapSignUp = styled(Text).attrs({
  align: 'center',
})`
  a {
    color: ${props => props.theme.colors.primary};
  }
`;
